<script setup lang="ts">
import type { InvestigationCollectionItem } from '@nuxt/content'

const props = defineProps<{
  article: InvestigationCollectionItem
}>()

const date = getDate(props.article.date)
</script>

<template>
  <div class="p-4 h-full">
    <article class="rounded-lg shadow-lg border overflow-hidden bg-neutral-100 dark:bg-neutral-900 border-neutral-200 dark:border-neutral-800 text-neutral-700 dark:text-neutral-200 flex flex-col h-full">
      <HomeSectionsInvestigationsItemsItemHeader :article="props.article" />
      <div class="p-4 flex-grow">
        <p class="mb-4 text-sm text-neutral-400 dark:text-neutral-500">
          {{ date }}
        </p>
        <p>{{ props.article.description }}</p>
      </div>
      <footer class="p-4 border-t border-neutral-200 flex dark:border-neutral-800">
        <div class="ml-auto flex gap-2">
          <VideoPreviewModal :url="props.article.video" :title="props.article.title">
            <UButton icon="bx:play" size="lg" variant="subtle" color="secondary">
              Bekijk video
            </UButton>
          </VideoPreviewModal>
          <UButton :to="props.article.path" icon="bx:book" size="lg" variant="subtle">
            Lees meer
          </UButton>
        </div>
      </footer>
    </article>
  </div>
</template>
